export enum ETutorialAudienceType {
  Restaurant = "Restaurant",

  Courier = "Courier",

  Both = "Both",
}
